import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ModelMap } from '@app/models/core/model-map.collection';
import { AuthService } from '@app/services';
import { Employee } from '@models/employee/employee.model';
import * as Sentry from '@sentry/angular';

@Injectable()
export class AccountEmployeeResolver {
    constructor(private auth: AuthService) {}

    async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<ModelMap> {
        if (!this.auth.hydrated) {
            Sentry.captureException(
                'Account resolver attempted to find employee without hydrating first. AuthGuard should always be called first, resulting in hydration',
                { level: 'debug' }
            );
            await this.auth.hydrate();
        }
        return new Promise<ModelMap>((resolve, _reject) => {
            const models = new ModelMap();
            Employee.param('company', this.auth.company.id)
                .with([
                    'account',
                    'address',
                    'job',
                    'department',
                    'office',
                    'manager',
                    'dataFields',
                    'dataFields.dataFieldGroup',
                    'employeeNamePronunciation',
                    'employeeNamePronunciation.file',
                ])
                .find(this.auth.employee.id)
                .then((employee) => {
                    models.set('employee', employee);
                    resolve(models);
                });
        });
    }
}
